import { styled } from '@mui/styles';
import { RadioGroup as MuiRadioGroup } from '@mui/material';

export const RadioGroup = styled(MuiRadioGroup)({
  marginBottom: '24px',
});
